// extracted by mini-css-extract-plugin
export default {"closeButton":"styles_closeButton__zM29r","container":"styles_container__cZv3o"};